cb.define(function () {
  var AA_aa_orgtreeref_referVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      var parentVM = viewmodel.getCache('parentViewModel');
      if (parentVM && parentVM.getParent() && parentVM.getParent().getParent()) {
        var gridModel = parentVM.getParent().getParent();
        var tree = viewmodel.get('tree');
        var keyField = tree.get('keyField');
        tree.on('afterMount', args=>{
          var rows = gridModel.getRows();
          var keys = [];
          rows.forEach(row => {
            if (keyField == 'id') {
              if (row.org) keys.push(String(row.org))
            } else {
              if (row.org_code) keys.push(row.org_code)
            }
          });
          tree.setState('checkedKeys', keys);
        });
      }
    }
  };

  try {
    module.exports = AA_aa_orgtreeref_referVM_Extend;
  } catch (error) {

  }
  return AA_aa_orgtreeref_referVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_orgtreeref_referVM.Extend.js